import { IonButton, IonIcon, IonItem, IonLabel, IonRadio, IonRadioGroup } from '@ionic/react';
import { arrowForwardOutline, businessOutline, personOutline, walletOutline } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import CadastroLayout, { CadastroSection } from '../CadastroLayout/CadastroLayout';
import './TipoConta.css';

const TipoConta: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const [accountType, setAccountType] = useState<'cpf' | 'cnpj'>('cpf');
  const [convite, setConvite] = useState('');

  useEffect(() => {
    setConvite(new URLSearchParams(location.search).get('convite') || '');
  }, [location.search]);

  return (
    <CadastroLayout title="Seu negócio começa aqui" description="Escolha como deseja se cadastrar. Na próxima etapa, vamos conhecer você e seu negócio." step={1} backHref={convite ? '/login-convite?convite=' + encodeURIComponent(convite) : '/login'} icon={walletOutline} badge="Sua conta Xeguei">
      <CadastroSection title="Qual tipo de conta deseja criar?" description="Selecione o documento que será usado no cadastro." icon={personOutline}>
        <IonRadioGroup className="cadastro-account-options" aria-label="Tipo de conta" value={accountType} onIonChange={e => setAccountType(e.detail.value)}>
          <IonItem lines="none" className={`cadastro-account-option ${accountType === 'cpf' ? 'is-selected' : ''}`}>
            <span className="cadastro-account-icon" slot="start"><IonIcon icon={personOutline} aria-hidden="true" /></span>
            <IonLabel><h3>Autônomo</h3><span className="cadastro-account-document">CPF</span><p>Para quem trabalha por conta própria e quer se cadastrar como pessoa física.</p></IonLabel>
            <IonRadio slot="end" value="cpf" aria-label="Autônomo (CPF)" />
          </IonItem>
          <IonItem lines="none" className={`cadastro-account-option ${accountType === 'cnpj' ? 'is-selected' : ''}`}>
            <span className="cadastro-account-icon" slot="start"><IonIcon icon={businessOutline} aria-hidden="true" /></span>
            <IonLabel><h3>Empresa</h3><span className="cadastro-account-document">CNPJ</span><p>Para negócios com CNPJ e cadastro vinculado a um responsável pela empresa.</p></IonLabel>
            <IonRadio slot="end" value="cnpj" aria-label="Empresa (CNPJ)" />
          </IonItem>
        </IonRadioGroup>
        <div className="cadastro-actions">
          <p>Você continuará com {accountType === 'cpf' ? 'uma conta de autônomo (CPF)' : 'uma conta de empresa (CNPJ)'}.</p>
          <IonButton className="cadastro-primary" onClick={() => {
            history.push((accountType === 'cpf' ? '/cadastro' : '/cadastro-cnpj') + (convite ? '?convite=' + encodeURIComponent(convite) : ''));
          }}>Próximo<IonIcon slot="end" icon={arrowForwardOutline} /></IonButton>
        </div>
      </CadastroSection>
    </CadastroLayout>
  );
};

export default TipoConta;
